export default {
  id: 'slack_invite',
  title: 'Invite message',
  type: 'Direct / Channel',
  canSendToChannel: true,
  description: 'Invite users to join the platform.',
  body: {
    blocks: [
      {
        type: 'section',
        text: {
          type: 'mrkdwn',
          text: '[[INPUT_INTRODUCTION_TEXT]]'
        }
      },
      {
        type: 'actions',
        elements: [
          {
            type: 'button',
            text: {
              type: 'plain_text',
              text: '[[INPUT_JOIN_BUTTON]]',
              emoji: true
            },
            url: '{{PLATFORM_LINK}}'
          }
        ]
      }
    ]
  },
  inputs: {
    INPUT_INTRODUCTION_TEXT: {
      label: 'Intro',
      placeholder: 'Hi all, ...',
      defaultValue: '<p>Hi all,</p><p>I am pleased to inform you that you can now join to our new referral platorm.</p><p>All you need to do is to click on the link below to start earning valuable rewards by sharing jobs and company content with your network.</p>',
      type: 'HTML'
    },
    INPUT_JOIN_BUTTON: {
      label: 'Button text',
      type: 'STRING',
      placeholder: 'Join now',
      defaultValue: 'Join now',
    },
  }
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/slack/picnic/invite.js